import * as z from 'zod'
import {
    DInstrumentListItem,
    DInstrumentTradeStat,
    DRightAndUnitTradeItem,
    DShareTradeItem,
    InstrumentListItem,
    InstrumentTradeStat,
} from '../Instrument.js'
import { GetApiContract, PatchApiContract } from './ApiContract.js'
import { ShallowDehydrateObject } from 'kysely'

export type GetInstrumentTradesResponse = {
    right: Record<string, Array<DRightAndUnitTradeItem>>
    share: Array<DShareTradeItem>
    unit: Record<string, Array<DRightAndUnitTradeItem>>
}

export interface GetInstrumentTradesRequest extends GetApiContract {
    Response: GetInstrumentTradesResponse
    ResponseJson: ShallowDehydrateObject<GetInstrumentTradesResponse>
}

export const getInstrumentQueryParamsSchema = z.object({
    endDate: z.iso.date(),
    numberOfDays: z.coerce.number(),
})

export interface GetInstrumentByIdRequest extends GetApiContract {
    QueryParameters: z.infer<typeof getInstrumentQueryParamsSchema>
    Response: DInstrumentTradeStat
    ResponseJson: InstrumentTradeStat
}

export const getInstrumentListQueryParamsSchema = z.object({
    listing: z.literal('delisted'),
})

export interface GetInstrumentListRequest extends GetApiContract {
    QueryParameters: z.infer<typeof getInstrumentListQueryParamsSchema>
    Response: Array<DInstrumentListItem>
    ResponseJson: Array<InstrumentListItem>
}

export const patchInstrumentsSchema = z.object({
    delistedReason: z.string(),
})

export interface PatchInstrumentsRequest extends PatchApiContract {
    Body: z.infer<typeof patchInstrumentsSchema>
    Response: z.infer<typeof patchInstrumentsSchema> & { id: string }
    ResponseJson: z.infer<typeof patchInstrumentsSchema> & { id: string }
}
